import { render, staticRenderFns } from "./Slides.vue?vue&type=template&id=5fbc5c0f&scoped=true"
import script from "./Slides.vue?vue&type=script&lang=js"
export * from "./Slides.vue?vue&type=script&lang=js"
import style0 from "./Slides.vue?vue&type=style&index=0&id=5fbc5c0f&prod&lang=css"
import style1 from "./Slides.vue?vue&type=style&index=1&id=5fbc5c0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc5c0f",
  null
  
)

export default component.exports